<template>
  <div>
    <div class="lxm-close-notification">
      <a class="lxm-close-notification__button button"
         :class="{ 'lxm-close-notification__button--highlight': highlight, 'is-loading': loading }"
         @click="clicked">
        <template v-if="open">
          <img v-if="highlight" class="lxm-close-notification__icon" src="../../images/main/close.png" />
          <img v-else class="lxm-close-notification__icon" src="../../images/main/close-white.png" />
          关闭本项目新消息提醒
        </template>
        <template v-else>
          <template v-if="!loading">
            <img v-if="highlight" class="lxm-close-notification__icon" src="../../images/main/cf/success.png" />
          </template>
          开启本项目新消息提醒
        </template>
      </a>
    </div>
    <div class="lxm-close-notification-placeholder"></div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-close-notification-placeholder
    height: footer-bar-height
  .lxm-close-notification
    position: fixed
    bottom: 0
    width: 100vw
    height: footer-bar-height
    background-color: brand-primary
    text-align: center
  .lxm-close-notification__button
    margin: siz(12.5) auto 0
    &.button
      border: 0
      font-size: size
      line-height: siz(15)
      padding-left: siz(10)
      padding-right: siz(10)
      height: siz(30)
      color: white
      background-color: brand-primary
      &.is-loading:after
        width: siz(16)
        height: siz(16)
        border-width: siz(2)
        margin-left: siz(-8)
        margin-top: siz(-8)
  .lxm-close-notification__button--highlight
    &.button
      color: brand-primary
      background-color: white
  .lxm-close-notification__icon
    width: siz(15)
    height: siz(15)
    margin-right: siz(5)
</style>

<script>
  export default {
    props: {
      highlight: Boolean,
      open: Boolean,
      loading: Boolean
    },
    methods: {
      clicked () {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmCloseNotification.vue?25dd932b